module.exports = __webpack_public_path__ + "img/upload-email-generic-fr.dcb38ec7.png";